<template>
    <div class="mb-3">
        <b-card no-body>
            <b-card-header class="p-1 pl-3">
                <h4>Account Security</h4>
            </b-card-header>
            <b-card-body>
                <b-button
                    block
                    size="sm"
                    variant="outline-primary"
                    v-b-modal.change-password
                >
                    Change password & Log off everywhere
                </b-button>
            </b-card-body>
        </b-card>
        <b-modal id="change-password" title="Change Password">
            <Input text="New password" v-model="newPassword" type="password" />
            <template v-slot:modal-footer="{ close }">
                <b-button size="sm" variant="outline-danger" @click="close()">
                    Cancel
                </b-button>
                <b-button
                    size="sm"
                    variant="warning"
                    @click="
                        $store
                            .dispatch('user/user/save', {
                                password: newPassword
                            })
                            .then(() => changePassword())
                            .catch(error => {
                                $bvToast.toast(error, {
                                    title: 'Error',
                                    variant: 'warning'
                                })
                            })
                    "
                >
                    Continue
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import Input from '@/components/form/input'
    import Cookies from 'js-cookie'

    export default {
        data() {
            return {
                newPassword: ''
            }
        },
        methods: {
            changePassword() {
                this.$root.$bvToast.toast('Password changed. Please login again.', {
                    title: 'Success',
                    variant: 'success'
                })
                Cookies.remove('auth')
                this.$router.push('/login')
            }
        },
        components: {
            Input
        }
    }
</script>

<style scoped>
</style>